import { SetHeader } from "./config"
import AccessAPI from "./access"
import DeviceListAPI from "./device"
import MyDevicesAPI from "./my-device"
import FavorateAPI from "./favorate"
import PaymentAPI from "./payments"
import DeviceGroupAPI from "./device-group"
import AnalysticAPI from "./analystic"
import UsersAPI from "./users"
import NoticeAPI from "./notice"
import RemoteAPI from "./remote"
import CheckAPI from "./check"
import ColumnReturnAPI from "./column_return"
import ConnDeviceGroupAPI from "./conn-device-groups"
import ManagersAPI from "./managers"
import MessageAPI from "./message"
import AccessTicketAPI from "./access-ticket"
import ApprovalAPI from "./approval"
import ApprovalsAPI from "./approvals"
import CompanyFunctionAPI from "./company-function"
import IPPolicyAPI from "./ip-policy"
import ConnUsersAPI from "./conn-users"
import ConnAPI from "./conn"
import UserExcelUploadAPI from "./user-excel-upload"
import DepartmentExcelUploadAPI from "./department-excel-upload"
import DeviceGroupsExcelAPI from "./device-groups-excel"
import AuthenticateDevicesAPI from "./authenticate-devices"
import ApprovalExcelUploadAPI from "./approval-excel-upload"
import UserEntityRegisterAPI from "./user-entity-register"
import UserEntityRegisterNotTokenAPI from "@/api/user-entity-register-not-token"
import ManagementAPI from "./management"
import ApprovalMacroAPI from "./approvalMacro"
import SecurityAgreementAPI from "./securityAgreement"
import DepartmentsAPI from "./department"
import DevicesUpdateAPI from "./device-update"
import RemoteAccessAgreementAPI from "./remote-access-agreement"
import GetMgridAPI from "./GetMgrid"
import { MdmProfileAPI, MdmAppAPI, MdmCompanywideAPI, MdmAssignAPI } from "./mdm"

export {
  AccessAPI,
  DeviceListAPI,
  MyDevicesAPI,
  FavorateAPI,
  PaymentAPI,
  DeviceGroupAPI,
  AnalysticAPI,
  UsersAPI,
  NoticeAPI,
  RemoteAPI,
  SetHeader,
  CheckAPI,
  ColumnReturnAPI,
  ConnDeviceGroupAPI,
  ManagersAPI,
  MessageAPI,
  AccessTicketAPI,
  ApprovalAPI,
  ApprovalsAPI,
  CompanyFunctionAPI,
  IPPolicyAPI,
  ConnUsersAPI,
  ConnAPI,
  UserExcelUploadAPI,
  DepartmentExcelUploadAPI,
  UserEntityRegisterNotTokenAPI,
  DeviceGroupsExcelAPI,
  AuthenticateDevicesAPI,
  ApprovalExcelUploadAPI,
  UserEntityRegisterAPI,
  ManagementAPI,
  ApprovalMacroAPI,
  SecurityAgreementAPI,
  DepartmentsAPI,
  DevicesUpdateAPI,
  RemoteAccessAgreementAPI,
  GetMgridAPI,
  MdmProfileAPI,
  MdmAppAPI,
  MdmCompanywideAPI,
  MdmAssignAPI,
}
